module.exports = __webpack_public_path__ + "media/images/icons/arrow-left-58711c6d56455dbaf906d8dee972ca62.svg";